import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PageLayoutComponent } from 'mbs-ui-shared@components/page-layout/page-layout.component';
import { ErrorComponent } from 'mbs-ui-shared@modules/error/error.component';
import { ErrorType } from 'mbs-ui-shared@modules/error/error.constants';

@Component({
  selector: 'mbs-not-found',
  templateUrl: 'not-found.component.html',
  styleUrls: ['not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ErrorComponent, PageLayoutComponent]
})
export class NotFoundComponent {
  public readonly errorType = ErrorType;
}
